import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppService } from './../@core/service/App.Service';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SessionService extends AppService<any> {
  constructor(private router: Router) {
    super('sessions');
  }

  async createSession(email: string, password: string) {
    const result = await this.post('', { email: email, password: password });
    return result;
  }

  async deleteSession(sessionID: string) {
    const result = await this.post('/deletesessions', {  sessionID});
    return result;
  }

  async getSessionInfo(sessionID: string) {
    const result = await this.post('/sessioninfo', {  sessionID});
    return result;
  }
  
  async logoutSession() {
    setTimeout(() => {
      let companyID = localStorage.getItem('companyId');
      localStorage.clear();
      localStorage.setItem('companyId',companyID);
      this.router.navigate([environment.logOut]);
    }, 200);
  }
}
